import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface BreadcrumbProps {
  assessmentName: string | React.ReactNode;
}

export function Breadcrumb({ assessmentName }: BreadcrumbProps) {
  return (
    <div className="flex items-center gap-2 text-sm mb-6">
      <Link
        to="/assessments"
        className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronLeft className="h-4 w-4" />
        <span>Back to Assessments</span>
      </Link>
      <span className="text-muted-foreground">|</span>
      <div className="font-medium text-foreground">
        {assessmentName}
      </div>
    </div>
  );
}
